export function getChartRef (refs, chartRefIdentifier) {
  const chartRef = refs[chartRefIdentifier]
  if (!chartRef) return null
  // @ts-ignore
  return chartRef.chart
}
